import { render, staticRenderFns } from "./child-navigation.vue?vue&type=template&id=5a92f856&scoped=true"
import script from "./child-navigation.ts?vue&type=script&lang=ts&external"
export * from "./child-navigation.ts?vue&type=script&lang=ts&external"
import style0 from "./child-navigation.less?vue&type=style&index=0&id=5a92f856&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92f856",
  null
  
)

export default component.exports